module.exports = __webpack_public_path__ + "static/nowak-c8454dc55fa1f671f6340909764aa4e7.jpg";